export default __webpack_public_path__ + "static/customer-experience-2462326977dc2a9b6a4989988a0e1f12.png";